var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H11.6667V6.66667H13.3333V8.33333H17.5V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM5 14.1667H15L11.875 10L9.375 13.3333L7.5 10.8333L5 14.1667ZM14.1667 7.5V5.83333H12.5V4.16667H14.1667V2.5H15.8333V4.16667H17.5V5.83333H15.8333V7.5H14.1667Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMediaIcon);
export default __webpack_public_path__ + "static/media/add-media-icon.74cf86c074c9cb18554e9f8e85096399.svg";
export { ForwardRef as ReactComponent };